module.exports = __webpack_public_path__ + "img/f15.7766d2c8.png";